import { render, staticRenderFns } from "./RuleEditionModal.vue?vue&type=template&id=18c6a314&scoped=true&"
import script from "./RuleEditionModal.vue?vue&type=script&lang=js&"
export * from "./RuleEditionModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleEditionModal.vue?vue&type=style&index=0&id=18c6a314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c6a314",
  null
  
)

export default component.exports